export const FLIP_ERRORS = {
  context: 'Flip component was not found in the tree',
  children:
    'Flip.Target component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported',
};
